import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';
import { AllegationsAdditionalInfoCase } from './../allegations-additional-info';
import { environment } from './../../../../../environments/environment';
import { JuvenileSearchService } from './../../../../juvenile/juvenile-search.service';
import { Allegations } from './../../../../juvenile/juvenile-case-sections/allegations';

declare var $: any;
@Component({
  selector: 'allegations-additional-info-view',
  templateUrl: './allegations-additional-info.component.html',
  styleUrls: ['./allegations-additional-info.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class AllegationsAdditionalInfoViewComponent {

  @Input() allegations: Allegations;
  private abstractCode: string;
  private showFieldCodeFlag = false;

  panelName:string = "ALLGN";
  showFieldCodeAction = 'Click to show field code';
  tocOpen1 = true;
  tocOpening1 = false;

  //searchRecordLastUpdateDate: string = DatePipeCorrectorUtil.fixFormat(new Date().toJSON());;

  constructor(private cd: ChangeDetectorRef,
              private juvenileSearchService: JuvenileSearchService) { }

  getAbstractJQCode(code: string): string {
    return code;
  }

  setPanelName(panelName: string):void {
    this.panelName = panelName;
    if (!environment.production) {
     // console.log('Panel Name ====' + panelName);      
    }
  }

  isSet(panelName: string): boolean {
    if (!environment.production) {
    //  console.log('Panel Name >>>>====' + panelName);      
    }
    return this.panelName === panelName;
    
  }

  isDispositionReslt(): boolean {
    return this.panelName === 'DSPNR';
  }

  showFieldCode() {
    // toggle the flag
    this.showFieldCodeFlag = !this.showFieldCodeFlag;

    // show/hide the field codes
    if (this.showFieldCodeFlag) {
      $('.field-code').show();
      this.showFieldCodeAction = 'Click to hide field code';
    } else {
      $('.field-code').hide();
      this.showFieldCodeAction = 'Click to show field code';
    }
  }

  toggleTableOfContents1() {
    this.tocOpen1 = !this.tocOpen1;
    if (this.tocOpen1) {
      this.tocOpening1 = true;
      setTimeout(() => {
        this.tocOpening1 = false;
        this.cd.markForCheck(); // force change detection to run to pick up this change
      }, 500); // Note: this duration must be the same as the transition duration in this component's styles
    }
  }

  isProd(): boolean {
    return environment.production;
  }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/case-view/juvenile/allegations/allegations-additional-info/allegations-additional-info.component.ts